import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
  uniform vec3 uColor1;
  uniform vec3 uColor2;
  uniform vec3 uColor3;
  uniform vec4 uRectData;
  uniform float uNoiseScale;

  varying vec3 vNormal;
  varying vec3 vNormal2;
  varying vec3 vWorldPosition;

  void main() {
    float n = snoise(vNormal2 * uNoiseScale) * 0.5 + 0.5;
    n = smoothstep(0.0, 1.0, n);

    float n2 = snoise(vNormal2 * uNoiseScale + vec3(-1.5)) * 0.5 + 0.5;
    // n2 = smoothstep(0.5, 1.0, n2);

    vec3 color = mix(uColor1, uColor2, n);

    #if PART == 0
      color = mix(color, uColor3, n2 * 0.3);
    #endif

    float n3 = snoise(vNormal2 * uNoiseScale + vec3(0.5)) * 0.5 + 0.5;
    n3 = smoothstep(0.0, 1.0, n3);

    vec3 hsv = rgb2hsv(color);
    hsv.g -= n3 * 0.2;
    hsv.b += n3 * 0.4;

    #if PART == 0
    hsv.b += n2 * 0.1;
    #endif
    color = hsv2rgb(hsv);

    ${frustumCull}

    // color = pow(color, vec3(1.0/2.2));
    gl_FragColor = vec4(color, 1.0);
  }
`
